import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';

export const StyledCircularProgress = styled(CircularProgress)<{
  $size?: number;
}>`
  width: ${(props) => props.$size}px !important;
  height: ${(props) => props.$size}px !important;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Wrapper = styled.div`
  display: inline-flex;
`;
